import { makeStyles } from "@material-ui/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

export default makeStyles((theme) => ({
  logotype: {
    color: "#ffffff",
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5),
    fontWeight: "500!important",
    lineHeight: 1.19,
    fontFamily: "Roboto",
    fontSize: "18",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  appBar: {
    width: "100vw",
    color: "white",
    zIndex: 1000,
    paddingRight:'0px !important',
    transition: theme.transitions.create(["margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  toolbar: {
    color: "white",
    paddingLeft: '0px !important',
    paddingRight:'0px !important',
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: "relative",
    borderRadius: 25,
    paddingLeft: theme.spacing(2.5),
    width: 36,
    backgroundColor: fade(theme.palette.common.black, 0),
    transition: theme.transitions.create(["background-color", "width"]),
    "&:hover": {
      cursor: "pointer",
      backgroundColor: fade(theme.palette.common.black, 0.08),
    },
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  searchFocused: {
    backgroundColor: fade(theme.palette.common.black, 0.08),
    color: "white",
    width: "100%",
    [theme.breakpoints.up("xs")]: {
      width: "auto",
    },
  },
  searchIcon: {
    width: 36,
    right: 0,
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create("right"),
    "&:hover": {
      cursor: "pointer",
    },
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  searchIconOpened: {
    right: theme.spacing(1.25),
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    height: "50px",
    backgroundColor: "#014e8c",
    width: "30%",
    borderTopRightRadius: "6px",
    borderBottomRightRadius: "6px",
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "auto",
    },
  },
  dropdownColor: {
    color: "white",
    border: "none",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
    marginRight: 0,
    [theme.breakpoints.down("xs")]: {
      display: "inline-block",
      width: "auto",
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  selectBox: {
    height: "50px !important",
    display: "flex",
    color:"white",
    paddingLeft:"10px",
    alignItems: "center",
    backgroundColor: "#014e8c",
    borderBottom: 0,
    " & :before": {
      borderBottom: 0,
    },
    " & :hover": {
      border: "none",
      borderBottom: 0,
    },
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  fieldset: {
    borderColor: "red",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
    borderLeft: "solid 1px #bdbdbd",
    paddingLeft: 10,
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "auto",
    },
  },
  inputInput: {
    height: 36,
    padding: 0,
    paddingRight: 36 + theme.spacing(1.25),
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "auto",
    },
  },
  messageContent: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenu: {
    marginTop: theme.spacing(7),
  },
  headerMenuList: {
    display: "flex",
    flexDirection: "column",
  },
  headerMenuItem: {
    "&:hover, &:focus": {
      backgroundColor: theme.palette.primary.main,
      color: "white",
    },
  },
  headerMenuButton: {
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5),
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  headerMenuButtonCollapse: {
    marginRight: theme.spacing(2),
  },
  headerIcon: {
    fontSize: 28,
    color: "#EEEEEE",
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  headerIconCollapse: {
    color: "#EEEEEE",
  },

  profileMenu: {
    minWidth: 208,
    width:'208px !important',
    backgroundColor:"#014e8c",
    boxShadow:'none',
    borderRadius:0,
    right:'0px !important',
    top:'10px !important',
    left:'unset !important'
  },
  profileMenuUser: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  profileMenuItem: {
    color: "#fff",
    padding: '.7em',
    fontSize: '1em',
     "&:hover": {
      cursor: "pointer",
      textDecoration: "none",
    },
  },
  profileMenuIcon: {
    marginRight: theme.spacing(2),
    color: "#fff",
    fontSize: '1.5em',
    "&:hover": {
      cursor: "pointer",
      textDecoration: "none",
    },
  },
  profileMenuLink: {
    fontSize: 16,
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "none",
    },
  },
  messageNotification: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
    },
  },
  messageNotificationSide: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  messageNotificationBodySide: {
    alignItems: "flex-start",
    marginRight: 0,
  },
  sendMessageButton: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  sendButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  notificationbox: {
    width: 356,
    heigth: 670,
    boxShadow: "-3px 0 6px 0  rgba(0,0,0,0.16)",
    //border:"solid 1px #014e8c" ,
    backgroundColor: "white",
  },

  notificationshow: {
    height: 45,
    width: 356,
    padding: 15,
    backgroundColor: "#014e8c",
    color: "white",
  },
  notificationnos: {
    width: "110px",
    height: "17px",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "500",
    fontStyle: "normal",
    fontStretch: "normal",
    textAlign: "left",
  },
  viewAll: {
    width: "43px",
    height: "14px",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    lineHeight: "1.17",
    letterSpacing: "normal",
    marginLeft: "180px",
    textAlign: "right",
    color: "white",
  },
  iconProfile:{
    backgroundColor:"transparent",
    borderRadius:"0px !important",
    padding:"17px !important"
  },
  iconProfile1:{
    backgroundColor:"#014e8c",
    borderRadius:"0px !important",
    padding:"17px !important"
  }
}));
